import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Edit3, Trash2, KeyRound, Loader2 } from "lucide-react";
import { PageContainer, PageHeader, Pill } from "@/components/layout/PageShell";
import { DataToolbar, DataTable } from "@/components/layout/DataTable";
import api from "@/lib/api";

export default function UsersPage() {
  const [search, setSearch] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const { data: res } = await api.get("/users");
      return res.users;
    },
  });

  const users = data || [];
  const filtered = users.filter(
    (u) =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.username?.toLowerCase().includes(search.toLowerCase()) ||
      u.email?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <PageContainer>
      <PageHeader title="Users" subtitle="Manage staff accounts and role assignments" />
      <DataToolbar searchValue={search} onSearch={setSearch} onAdd={() => {}} addLabel="New User" testIdPrefix="users" />
      {isLoading ? (
        <div className="h-32 grid place-items-center text-slate-500">
          <Loader2 className="h-5 w-5 animate-spin" />
        </div>
      ) : (
        <DataTable
          testIdPrefix="users"
          columns={[
            { key: "name", label: "Name", bold: true },
            { key: "username", label: "Username", mono: true },
            { key: "role", label: "Role", render: (v) => <Pill tone="blue">{v}</Pill> },
            { key: "branch", label: "Branch" },
            { key: "lastLogin", label: "Last Login" },
            { key: "status", label: "Status", render: (v) => <Pill tone={v === "Active" ? "green" : "red"}>{v}</Pill> },
          ]}
          rows={filtered}
          rowActions={() => [
            { title: "Reset", icon: <KeyRound size={14} /> },
            { title: "Edit", icon: <Edit3 size={14} /> },
            { title: "Delete", icon: <Trash2 size={14} />, danger: true },
          ]}
        />
      )}
    </PageContainer>
  );
}
